<template>
  <div class="table-op-col-bdr">
    <!-- <div class="title_header">
      账户资金
    </div> -->
    <div class="balance_box">
      <div class="balance_content">
        <div class="f_14 c_bbb">总余额</div>
        <div
          class="clearfix"
          style="padding-bottom: 32px; border-bottom: 1px solid #e9e9e9"
        >
          <div class="f_l">
            <span class="c_red f_24">¥</span>
            <span class="c_red f_48">{{ overageAmount }}</span>
          </div>
          <div class="f_l btn_box">
            <el-button
              v-track="{ action: 'account_charge' }"
              style="background: #dc1e32; color: #fff"
              @click="tipsboxShow"
              v-if="permissions.recharge"
              >充值</el-button
            >
            <el-button
              v-track="{ action: 'account_cash' }"
              plain
              style="
                border-color: #dc1e32;
                color: #dc1e32;
                margin-left: 24px;
                opacity: 0.4;
              "
              @click="getMoney"
              v-if="permissions.withdrawal"
              >提现</el-button
            >
          </div>
        </div>
        <div class="clearfix" style="margin-top: 32px">
          <div class="availableBalance f_l pos-rel">
            <div class="f_14 c_bbb">可用金额</div>
            <div style="margin-bottom:15px;">
              <span class="f_16" style="color: #2a2a2a">¥</span>
              <span class="f_32">{{ availableMoney }}</span>
            </div>
            <div class="flex" style=" justify-content:space-between;color:#666;font-size:14px;">
              <div style="width:285px" class="a_noline">
                <span>未分配：￥{{ unAssignAmount }}</span>
                <router-link to="/manage/AssignMoney"
                  ><span class="fs14 red iAssign">分配 <i class="el-icon-arrow-right"></i></span></router-link
                >
              </div>
              <div style="width:225px">
                <span>已分配：￥{{   assignAmount }}</span>
              </div>
            </div>
          </div>
          <div
            class="freezeBalance f_l"
            style="padding-right: 120px"
          >
            <div class="f_14 c_bbb">冻结金额</div>
            <div>
              <span class="f_16" style="color: #2a2a2a">¥</span>
              <span class="f_32">{{ freezeAmount }}</span>
            </div>
          </div>
          <!-- <div class="freezeBalance f_l">
            <div class="f_14 c_bbb">剩余可分配金额</div>
            <div>
              <span class="f_16" style="color: #2a2a2a">¥</span>
              <span class="f_32">{{ releaseAssign }}</span>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="detail_box">
      <div class="detail_content">
        <!-- <div style="font-size: 16px; color: #000000">账户明细</div> -->
        <div class="tab_box">
          <div class="date_box">
            <el-date-picker
              v-model="dateVal"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:dd"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <el-button
              v-if="permissions.account_query"
              v-track="{ action: 'account_query' }"
              style="background: #dc1e32; color: #fff; margin-left: 15px"
              @click="queryAccountFlow"
              >查询</el-button
            >
          </div>

          <el-tabs
            class="account-tab"
            v-model="activeName"
            @tab-click="handleClick"
          >
            <el-tab-pane label="充值明细" name="first">
              <el-table :data="tableData" style="width: 100%" height="280">
                <el-table-column prop="operateDate" label="时间">
                </el-table-column>
                <el-table-column
                  prop="amountStr"
                  label="金额（元）"
                  width="180"
                >
                </el-table-column>
                <el-table-column prop="historyAmountStr" label="历史余额（元）">
                </el-table-column>
                <el-table-column prop="totalAmountStr" label="总余额（元）">
                </el-table-column>
                <el-table-column prop="markMessage" label="备注">
                </el-table-column>
              </el-table>
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </el-tab-pane>
            <!-- <el-tab-pane label="项目额度" name="second">
              
            </el-tab-pane> -->
            <!-- <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
            <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
            <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane> -->
          </el-tabs>
        </div>
      </div>
    </div>

    <el-dialog
      @closed="eclosedAssign"
      width="450px"
      title="分配额度"
      :visible.sync="assign.adjVisible"
    >
      <div class="cnt">
        <div class="flex jc-center fs14" style="margin-bottom: 15px">
          <div style="margin-right: 20px">
            剩余可分配金额<span class="red">￥{{ releaseAssign }}</span>
          </div>
          <div>
            项目已分配额度<span class="red"
              >￥{{ assign.adjust.availMoney }}</span
            >
          </div>
        </div>
        <el-form
          size="mini"
          ref="assginForm"
          :rules="assign.adjust.rules"
          :model="assign.adjust.form"
          label-width="170px"
        >
          <el-form-item label="请选择调整关系" prop="ship">
            <el-select
              v-model="assign.adjust.form.ship"
              placeholder="请选择调整关系"
            >
              <el-option label="调增" value="+"></el-option>
              <el-option label="调减" value="-"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="请填写金额" prop="assignMoney">
            <el-input v-model="assign.adjust.form.assignMoney"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="assign.adjVisible = false"
          >取 消</el-button
        >
        <el-button size="mini" type="danger" @click="onAssignConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      width="750px"
      title="分配记录"
      :visible.sync="assign.listVisible"
    >
      <div class="cnt">
        <el-table
          :data="assign.record.table"
          style="width: 100%"
          v-loading="assign.record.loading"
        >
          <el-table-column prop="operator" label="操作人"></el-table-column>
          <el-table-column prop="createTm" label="操作时间"></el-table-column>
          <el-table-column prop="opDesc" label="操作内容"></el-table-column>
          <el-table-column prop="comment" label="备注"></el-table-column>
        </el-table>
        <el-pagination
          @current-change="onAssignRec_currChange"
          :current-page.sync="assign.record.pageNum"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="assign.record.total"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="充值提示" :visible.sync="dialogTableVisible">
      <div style="border-bottom: 1px dashed #ccc">
        <div class="f_16 m_b24">请使用绑定的银行卡，将金额转入下方账户：</div>
        <div class="m_b24">
          <span>开户名称：</span>
          <span style="color: #000">{{ bankAccount }}</span>
        </div>
        <div class="m_b24">
          <span>银行账号：</span>
          <span style="color: #000">{{ bankCard }}</span>
        </div>
        <div class="m_b24">
          <span>开户行：</span>
          <span style="color: #000">{{ bankName }}</span>
        </div>
        <div class="m_b24">
          <span>银行联行号：</span>
          <span style="color: #000">{{ bankUnionNumber }}</span>
        </div>
      </div>
      <div style="margin-top: 20px">
        <div class="f_16 m_b24">说明</div>
        <div>
          <el-table
            :data="descTableData"
            :span-method="objectSpanMethod"
            :highlight-current-row="false"
            :stripe="false"
            :selectable="false"
            :header-cell-style="{ background: 'rgb(250,250,250)' }"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="totalAmount"
              label="充值总额"
              width="180"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="transferDate"
              label="转账日期"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="transferTime"
              label="转账时间"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="transferAging"
              label="转账时效"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center">
            </el-table-column>
          </el-table>
          <div
            style="
              border-bottom: #ebeef5 1px solid;
              height: 50px;
              line-height: 50px;
            "
          >
            注：具体到账时间以银行为准
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="dialogTableVisible = false"
          style="background: #dc1e32; color: #fff"
          >知道了</el-button
        >
      </span>
    </el-dialog>
<!--    提现-->
    <el-dialog title="提现" width="40%" :visible.sync="show.showTixian">
      <el-form :inline="true" size="mini" label-width="150px">
        <el-row>

          <el-form-item label="请选择到账的银行卡">
            <el-select style="width: 120%" v-model="txForm.bankCardNumber" placeholder="请选择">
              <el-option v-for="item in cardList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="提现金额">
            <el-input style="width: 120%"  v-model="txForm.amount" :placeholder="getMoneyPlaceholder"></el-input>
          </el-form-item>
        </el-row>
       <el-row>
         <el-form-item label="不可提现金额:">
           <span>{{   assignAmount }},</span>
           <span style="color: #d42a2a;cursor: pointer" @click="inputAllMoney">&nbsp;&nbsp;&nbsp;&nbsp;全部提现</span>
         </el-form-item>
       </el-row>

      </el-form>
      <el-row>
        <table  style="border-spacing: 0px 0px;width: 100%;text-align: center;">
          <tr >
            <td style="border:1px solid black;border-right: none;">提现金额</td>
            <td style="border:1px solid black;border-right: none;">提现日期</td>
            <td style="border:1px solid black">到账失效</td>
          </tr>
          <tr>
           <td style="border:1px solid black;border-right: none;border-top: none;">&lt;=100万</td>
           <td style="border:1px solid black;border-right: none;border-top: none;">周一至周日</td>
           <td style="border:1px solid black;border-top: none;">实时到账</td>
          </tr>
          <tr>
            <td  style="border:1px solid black;border-right: none;border-top: none;">&gt;=100万</td>
            <td  style="border:1px solid black;border-right: none;border-top: none;">周一至周五</td>
            <td  style="border:1px solid black;border-top: none;">当日到账</td>
          </tr>
          <tr>
            <td  style="border:1px solid black;border-right: none;border-top: none;">&gt;=100万</td>
            <td  style="border:1px solid black;border-right: none;border-top: none;">周六至周日</td>
            <td  style="border:1px solid black;border-top: none;">次日到账</td>
          </tr>
        </table>
        <div style="height: 20px"></div>
        <div style="width: 100%;text-align: center">
          <el-button  @click="onReset">取消</el-button>
          <el-button style="margin-left: 80px"  v-track="{ action: 'usualLine_query' }" type="danger" @click="startGetMoney">确认</el-button>
        </div>
        <div style="height: 10px"></div>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import fetchPost from "@/api/http.js";
import { mapActions } from "vuex";
export default {
  data() {
    let validateLimit = (rule, value, callback) => {
      let release = parseFloat(this.releaseAssign);
      let adj = this.assign.adjust;
      let currItem = parseFloat(adj.availMoney);
      if (adj.form.ship == "+" && release < value) {
        callback(new Error("可分配金额不足！"));
      } else if (adj.form.ship == "-" && currItem < value) {
        callback(new Error("项目可用额度不足！"));
      } else {
        callback();
      }
    };
    return {
      permissions: {
				recharge: false,      //充值
        withdrawal: false,    //提现
        account_query: false  //查询
			},
      show: {
        Dispatch_Money: false,
        showTixian:false,
      },
      txForm:{
        amount:null,//提现金额
        bankCardNumber:null,//银行卡号
        accountType:null,//账户类型
        bankName:null,//开户行名称
        userType:null,//用户类型
      },
      releaseAssign: null,
      assign: {
        adjVisible: false,
        listVisible: false,
        tab: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          table: [],
        },
        record: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          table: [],
          loading: false,
        },
        adjust: {
          availMoney: 0,
          form: {
            ship: "+",
            assignMoney: "",
          },
          rules: {
            assignMoney: [
              { required: true, message: "请填写金额", trigger: "change" },
              { validator: validateLimit, trigger: "change" },
            ],
          },
        },
      },

      totalBalance: 100000.23,
      freezeAmount: "",
      overageAmount: "",
      availableMoney: "",
      unAssignAmount: "",
      assignAmount: "",
      activeName: "first",
      dateVal: "",
      currentPage: 1,
      tableData: [],
      total: 0,
      dialogTableVisible: false,
      bankCard: "",
      bankName: "",
      bankAccount: "",
      bankUnionNumber: "",
      descTableData: [
        {
          totalAmount: "<100万",
          transferDate: "周一至周日",
          transferTime: "00:00-24:00",
          transferAging: "7*24小时实时到账",
          remark: "一",
        },
        {
          totalAmount: "≥100万",
          transferDate: "周一至周四",
          transferTime: "00:00-17:00",
          transferAging: "实时到账",
          remark: "其他时间段无法到账",
        },
        {
          totalAmount: "≥100万",
          transferDate: "周一至周四",
          transferTime: "20:00-24:00",
          transferAging: "实时到账",
          remark: "其他时间段无法到账",
        },
        {
          totalAmount: "≥100万",
          transferDate: "周五",
          transferTime: "00:00-17:00",
          transferAging: "实时到账",
          remark: "其他时间段无法到账",
        },
        {
          totalAmount: "≥100万",
          transferDate: "周六、日/节假日",
          transferTime: "00:00-24:00",
          transferAging: "一",
          remark: "转账可能失败",
        },
      ],
      cardList:[],
      getMoneyPlaceholder:null
    };
  },
  watch: {
    dateVal(val) {
      console.log(val);
    },
  },
  filters: {
    balanceFilter(val) {
      if (val >= 0) {
        if (val >= 10000) {
          var valStr = val + "";
          var temp;
          var arr = valStr.split(".");
          if (arr[1]) {
            temp = arr[0] / 1000 + ",000" + "." + arr[1];
          } else {
            temp = arr[0] / 1000 + ",000" + ".00";
          }
          return temp;
        } else {
          return val;
        }
      }
    },
  },
  created() {
    let map = JSON.parse(sessionStorage.getItem("menuMap"));
    let submenuList = map["PlatformAccount"].split("-");
    submenuList.forEach((item, idex) => {
      this.show[item] = true;
      idex == 0 && (this.activeTab = item);
    });
    this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
  },
  mounted() {
    this.queryAccountOverage();
    this.queryAccountFlow();
    this.initCard();
    /* this.getItemList(); */
  },
  methods: {
    ...mapActions(["getItemListApi", "getAssignRecordListApi", "assignApi","queryBankCards","txFromSettle"]),

    onReset(){
      this.show.showTixian=false;
      this.txForm.amount=null;
      this.txForm.bankCardNumber=null;
    },
    inputAllMoney(){
      this.txForm.amount=this.unAssignAmount
    },
    paramCheck(){
      if (!this.txForm.bankCardNumber){
        return '未选择提现银行卡';
      }
      let v=this.txForm.amount;
      if (!v){
          return '请输入提现金额';
      }
      if (v){
          if (isNaN(v * 1)||v < 0) {
            return '提现金额应填写大于0的数字';
          }
          let unAssignAmount = this.unAssignAmount;
          if (v > unAssignAmount) {
            return '提现金额不能超过未分配金额';
          }

      }
      return null;

    },
    getMoney(){
      this.show.showTixian=true;

    },
    startGetMoney(){

      let paramCheck1 = this.paramCheck();
      if(paramCheck1!=null){
        this.$message({
          type: "error",
          message: paramCheck1,
        });
        return;
      }
      let bankName=""
      for (let i=0;i<this.cardList.length;i++){
        console.log(this.cardList[i].value,this.txForm.bankCardNumber)
        if (this.txForm.bankCardNumber==this.cardList[i].value){
           bankName=this.cardList[i].bankName;
        }
      }
      let param={
        "money":this.txForm.amount,
        "bankCardNumber":this.txForm.bankCardNumber,
        "accountType":1,
        "bankName":bankName,
        "userType":2,
      }
      this.txFromSettle(param).then((res) => {
        if (res.success==true||res.success=='true'){
          this.$message({
            type: "success",
            message: "提现成功请静候到账",
          });
          this.onReset();
          location.reload();
          return;
        }else {
          this.$message({
            type: "error",
            message: "提现失败"
          });
        }
      }).catch((e) => {});
    },
    initCard(){
      if (this.cardList!=null&&this.cardList.length>0){
        return;
      }
      this.queryBankCards(null).then((res) => {
        if (res.obj){
          this.txForm.bankCardNumber=res.obj[0].fullBankCardNumber;
          for (let i=0;i<res.obj.length;i++){
            let status=""
            if (res.obj[i].status==1){status="无效"}
            if (res.obj[i].status==2){status="注销"}
            if (res.obj[i].status==-1){status="绑卡中"}
            if (res.obj[i].status==0){status="有效"}
            let temp={
              value:res.obj[i].fullBankCardNumber,
              label:res.obj[i].bankName+","+res.obj[i].fullBankCardNumber+","+status,
              bankName:res.obj[i].bankName
            }
            this.cardList.push(temp)
          }
        }
      }).catch((e) => {});
    },
    tipsboxShow() {
      this.dialogTableVisible = true;
      this.recharge();
    },
    onAssignRecord(row) {
      this.getAssignRecordList();
    },
    getItemList() {
      let params = {
        pageSize: 10,
        pageNum: this.assign.tab.pageNum,
      };
      this.getItemListApi(params).then((res) => {
        this.assign.tab.table = res.rows;
        this.assign.tab.total = res.totalCount;
      });
    },
    getAssignRecordList() {
      let params = {
        pageSize: 10,
        pageNum: this.assign.record.pageNum,
      };
      this.getAssignRecordListApi(params).then((res) => {
        this.assign.record.table = res.rows;
        this.assign.record.total = res.totalCount;
        this.assign.listVisible = true;
      });
    },
    onAssign(row) {
      this.assign.adjVisible = true;
    },
    onAssignConfirm() {
      this.$refs.assginForm.validate((valid) => {
        if (valid) {
          let ship = this.assign.adjust.form.ship;
          let money = this.assign.adjust.form.assignMoney;
          if (ship != "+") {
            money = "-" + money;
          }
          this.assignApi({ assignMoney: money }).then((res) => {
            this.$message({
              type: "success",
              message: "分配成功",
            });
            this.assign.adjVisible = false;
            this.getAssignRecordList();
          });
        }
      });
    },
    eclosedAssign() {
      this.$refs.assginForm.resetFields();
    },
    onItems_currChange(val) {
      this.assign.tab.pageNum = val;
      this.getItemList();
    },
    onAssignRec_currChange(val) {
      this.assign.record.pageNum = val;
      this.getAssignRecordList();
    },
    recharge() {
      fetchPost("/saas/bankAccountBind/recharge", {}).then((res) => {
        this.bankCard = res.bankCard;
        this.bankName = res.bankName;
        this.bankAccount = res.bankAccount;
        this.bankUnionNumber = res.bankUnionNumber;
      });
    },
    queryAccountOverage() {
      fetchPost("/saas/bankAccountBind/queryAccountOverage", {})
        .then((res) => {
          this.overageAmount = res.overageAmountStr;
          this.freezeAmount = res.freezeAmountStr;
          this.unAssignAmount = res.unAssignAmount;
          this.availableMoney = res.availableMoneyStr;
          this.getMoneyPlaceholder="可提现金额:"+this.unAssignAmount;
          this.assignAmount = res.assignAmount?res.assignAmount:0;
        })
        .catch((e) => {});
    },
    queryAccountFlow() {
      var data = {
        pageNum: this.currentPage,
        pageSize: 10,
        startTm: "",
        endTm: "",
      };
      if (this.dateVal && this.dateVal.length > 0) {
        data.startTm = this.dateVal[0];
        data.endTm = this.dateVal[1];
      }
      fetchPost("/saas/bankAccountBind/queryAccountFlow", data).then((res) => {
        this.tableData = res.list;
        this.total = res.total;
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryAccountFlow();
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex > 0) {
          if (rowIndex === 1) {
            return {
              rowspan: 4,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      }
      if (columnIndex === 1 || columnIndex > 2) {
        if (rowIndex > 0 && rowIndex < 3) {
          if (rowIndex === 1) {
            return {
              rowspan: 2,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.iAssign {
  cursor: pointer;
   margin-left:15px!important;
}
#app .account-tab /deep/ .el-tabs__nav-wrap::after {
  background-color: rgb(233, 233, 233);
}
.account-tab /deep/ .el-tabs__header.is-top {
  margin-bottom: 25px !important;
}
.account-tab.el-tabs--top /deep/ .el-tabs__item.is-top:nth-child(2) {
  padding-left: 0 !important;
}
.account-tab.el-tabs--top /deep/ .el-tabs__item.is-top:last-child {
  padding-right: 0 !important;
}
.el-date-editor--datetimerange.el-input__inner {
  width: 345px;
}
.m_b24 {
  margin-bottom: 16px !important;
}
.f_14 {
  font-size: 14px;
}
.f_16 {
  font-size: 16px;
}
.f_24 {
  font-size: 24px;
}
.f_32 {
  font-size: 32px;
  color: #2a2a2a;
  letter-spacing: 1.45px;
  line-height: 46px;
}
.f_48 {
  font-size: 48px;
  line-height: 68px;
  letter-spacing: 2.18px;
}
.c_bbb {
  color: #bbbbbb;
}
.c_red {
  color: #dc1e32;
}
.f_l {
  float: left;
}
.btn_box {
  margin-left: 70px !important;
  margin-top: 20px !important;
}
.availableBalance {
  padding-right: 120px !important;
  border-right: 1px solid #e9e9e9;
}
.freezeBalance {
  padding-left: 120px !important;
}
// .btn_box  .el-button{
//   background: #DC1E32;
//   color: #fff;
// }
.title_header {
  height: 80px;
  line-height: 80px;
  font-size: 20px;
  color: #000000;
  padding-left: 56px !important;
  background: #fff;
  font-family: PingFangSC-Semibold;
}
.balance_box {
  background: #f1f1f1;
  .balance_content {
    height: 325px;
    background: #fff;
    padding: 40px 32px !important;
    box-sizing: border-box;
    box-shadow: 0 -6px 20px 0 rgba(0, 0, 0, 0.15);
  }
}
.detail_box {
  background: #f1f1f1;
  padding-top: 10px !important;
  .detail_content {
    height: 466px;
    background: #fff;
    padding: 24px 32px !important;
    box-sizing: border-box;
    .tab_box {
      margin-top: 30px !important;
      position: relative;
      .date_box {
        position: absolute;
        right: 50px;
        top: -9px;
        z-index: 1001;
      }
    }
  }
}
/deep/.el-tabs__item.is-active {
  color: #dc1e32 !important;
}
.clearfix:after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}

.clearfix:after {
  *zoom: 1;
  /*针对IE6/IE7*/
}

.el-table {
  /deep/tbody tr:hover > td {
    background-color: white;
  }
}
.a_noline a{
      text-decoration: none;
}
</style>
